import script from "./RaceInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./RaceInfo.vue?vue&type=script&setup=true&lang=js"

import "./RaceInfo.vue?vue&type=style&index=0&id=bb9c4388&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb9c4388"]])

export default __exports__